import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'preact/hooks';

export interface Event {
  _id: string;
  eventType: string;
  startTime: string;
  stopTime: string;
  businessHourId: string;
  title: string;
  description: string;
  habitatId: string;
  habitatSlug: string;
  animal: string;
  habitatImage: string;
  habitatDescription: string;
  wideImage: string;
  isStreamOn: boolean;
  isHostStreamOn: boolean;
  habitatDisabled: boolean;
  zoo: string;
  zooLogo: string;
  zooSlug: string;
  zooId: string;
}

const useEventsQuery = (params: {
  startTime: number;
  endTime: number;
  animals?: string[];
  zoos?: string[];
  events?: string[];
  pageSize?: number;
  enabled?: boolean;
}) => {
  const { startTime, endTime, pageSize, zoos, events, animals, enabled = true } = params;
  const paramsString = useMemo(() => {
    const params = new URLSearchParams({
      startTime: startTime.toString(),
      endTime: endTime.toString(),
      pageSize: pageSize ? pageSize.toString() : '99',
      page: '1',
    });
    zoos?.forEach((zooId) => {
      params.append('zoos[]', zooId);
    });
    events?.forEach((event) => {
      params.append('events[]', event);
    });
    animals?.forEach((animal) => {
      params.append('animals[]', animal);
    });
    return params.toString();
  }, [startTime, endTime, pageSize, zoos, events, animals]);

  return useQuery<Event[]>({
    queryKey: [`/schedules/events?${paramsString}`],
    enabled,
  });
};

export default useEventsQuery;
